import React from "react";
import { Grid, Typography } from "@material-ui/core";
import { PRICE_HIDDEN_THANK_YOU_MESSAGE } from "./priceDisplay";

const PriceHiddenThankYou = () => (
  <Grid
    container
    style={{ width: "70%", margin: "0 auto", height: "100vh" }}
    justifyContent="center"
  >
    <Grid xs={10} item>
      <Typography
        color="primary"
        variant="h1"
        style={{ fontSize: "4rem", textAlign: "center" }}
      >
        Success!
      </Typography>
      <Typography
        color="textPrimary"
        variant="body1"
        style={{ fontSize: "1.5rem", textAlign: "center" }}
      >
        {PRICE_HIDDEN_THANK_YOU_MESSAGE}
      </Typography>
    </Grid>
  </Grid>
);

export default PriceHiddenThankYou;
